import React, { useState, useEffect } from 'react';
import styles from './LoginButton.module.css';
import LoginForm from '../Login/LoginForm.jsx';
import Profile from '../Profile/Profile.jsx';
import solanaLogo from './assets/solanaLogoMark.png';
import useWalletStore from '../../providers/walletStore.js';
import { useSupabaseStore } from '../../providers/supabaseStore.js';

const LoginButton = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const { wallet, connectWallet } = useWalletStore();
  const { points, fetchPoints } = useSupabaseStore();

  useEffect(() => {
    if (wallet?.address) {
      fetchPoints(wallet.address);
    }
  }, [wallet?.address, fetchPoints]);

  const handleWalletConnect = async (info) => {
    await connectWallet();
    setShowLoginModal(false);
  };

  if (wallet) {
    return (
      <>
        <button 
          className={styles.profileButton} 
          onClick={() => setShowProfile(!showProfile)}
        >
          <div className={styles.chainInfo}>
            <img 
              src={solanaLogo}
              alt="Solana" 
              className={styles.chainIcon} 
            />
          </div>
          <div className={styles.addressInfo}>
            <span className={styles.address}>{wallet.shortAddress}</span>
          </div>
          <div className={styles.pointsInfo}>
            {points || 0} pts
          </div>
          <span className={styles.menuDots}>⋮</span>
        </button>
        {showProfile && <Profile onClose={() => setShowProfile(false)} />}
      </>
    );
  }

  return (
    <>
      <button 
        className={styles.loginButton}
        onClick={() => setShowLoginModal(true)}
      >
        Log In
      </button>
      {showLoginModal && (
        <LoginForm 
          onClose={() => setShowLoginModal(false)} 
          onWalletConnect={handleWalletConnect}
        />
      )}
    </>
  );
};

export default LoginButton;
